<template>
  <b-card class="contact-card vertical d-flex flex-column contact-card-shadow col-sm-3 col-xxs-10 px-0 mt-2" no-body>
    <b-card-header class="d-flex justify-content-center" :class="configurations.classList">
      <img :src="configurations.imageUrl" width="128">
    </b-card-header>
    <b-card-body class="d-flex flex-column align-items-center justify-content-between py-4">
      <strong class="d-flex pt-3 text-center text-dark" v-html="configurations.text" />
      <b-link
        class="d-flex"
        :class="configurations.linkClassList"
        :target="configurations.target"
        :to="to()"
        :href="href()"
      >
        {{ configurations.linkText }}
      </b-link>
    </b-card-body>
  </b-card>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'LinkCardVertical',
  props: {
    configurations: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    to () {
      if (this.configurations.linkUrl[0] === '/') { return this.configurations.linkUrl }
      return ''
    },
    href () {
      if (this.configurations.linkUrl[0] !== '/') { return this.configurations.linkUrl }
      return ''
    }
  }
})
</script>
